import {PropsWithChildren, useCallback, useMemo} from "react";
import {autologinTqo, useAuthenticator} from "../auth/authenticator.tsx";
import {merge} from "lodash";
import {useQueryClient} from "@tanstack/react-query";
import {KingBasura, KingBasuraMamaContext} from "./webrpc-client.gen.ts";
import {join} from "remeda";

export const HTTP_CONFLICT_STATUS = 409;
export const HTTP_UNAUTHORIZED_STATUS = 401;
export const HTTP_BAD_REQUEST = 400;

// const MamaContext = createContext<KingBasura>({} as KingBasura);

export function mothershipApiBaseUrl() {
    // it's sort of challenging to identify base urls. we need to be able
    // to have complete ones (for development where https is not available),
    // we need to be able to have "" or "./" be relative, and we need to
    // have vendors be concatenated.
    // anything that matches complexBaseUrlRegex is passed straight through.
    const complexBaseUrlRegex = /[^A-Za-z_-]/;
    // // anything that *doesn't* match nonBlankRegex is considered blank and
    // // collapses to '/' for the purposes of locating zrpc.
    // const nonBlankRegex = /\S/;

    let apiBase: string;
    let baseurl = import.meta.env.BASE_URL;
    const mamabase = import.meta.env.VITE_MOTHERSHIP_BASE;
    if (complexBaseUrlRegex.test(mamabase)) {
        apiBase = mamabase;
    } else {
        if (baseurl.startsWith(".")) {
            baseurl = baseurl.substring(1);
        }
        apiBase = join([baseurl, mamabase], baseurl.endsWith("/") ? "" : "/")
    }
    // console.log(`api base is ${apiBase}`)

    return apiBase;
}

export function MothershipProvider({children}: PropsWithChildren) {
    const tqc = useQueryClient();
    const auther = useAuthenticator();
    // const dispatchAuthToken = useContext(AuthTokenDispatchContext);
    const fetcher = useCallback((input: RequestInfo, init?: RequestInit) => {
        const rv$: Promise<Response> = (auther.getJwt()
            ? Promise.resolve(auther.getJwt())
            : tqc.ensureQueryData(autologinTqo).then(({wantsAutologin, storedAuthtoken}) => {
                if (wantsAutologin) {
                    auther.setJwt(storedAuthtoken ?? null);
                    return storedAuthtoken;
                }
            })).then(jwt => {
            if (jwt) {
                return {...init, headers: merge(init?.headers, auther.getAuthorizationHeader())};
            } else {
                return init;
            }
        }).then(xinit => {
            return fetch(input, xinit)
                .then(rsp => {
                    if (!rsp.ok) {
                        if (rsp.status === HTTP_CONFLICT_STATUS || rsp.status === HTTP_UNAUTHORIZED_STATUS) {
                            auther.setJwt(null);
                        }
                    }
                    return rsp;
                });
        });
        return rv$;
    }, [auther, tqc]);

    const apiBase = mothershipApiBaseUrl();

    const mama = useMemo(() => {
        return new KingBasura(apiBase, fetcher);
    }, [apiBase, fetcher]);

    return <KingBasuraMamaContext value={mama}>{children}</KingBasuraMamaContext>
}

//
// export function useMothership() {
//     const rv = useContext(MamaContext);
//     return rv;
// }

// export function useLogout(): () => void {
//     const auth = useAuthenticator();
//     const mama = useMothership();
// }

